var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn_wrapper"},[[_c('p',{staticClass:"description"},[_c('btn',{attrs:{"custom-class":"btn-request-demo","text":_vm.$t('requestDemo'),"href":"contact-us","target":"_blank"}})],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }